import React from 'react';
import { isEmpty } from 'lodash';

import { useChatContext } from '~/components/AiChat/hooks/useChat';
import { useClaim } from '~/components/ClaimContainer';
import CliveMarkdownDisplay from '~/components/Clive/CliveMarkdownDisplay/CliveMarkdownDisplay';
import type { ListItem } from '~/components/core/Molecules/OverflowList/Chips';
import { OverflowChipsList } from '~/components/core/Molecules/OverflowList/Chips';
import FileIcon from '~/components/icons/FileIcon';

import type { HumanMessageContentProps } from './MessageTypes';

/**
 * Human-specific message content component.
 * Renders document chips and message text.
 */
export const HumanMessageContent: React.FC<HumanMessageContentProps> = ({
  text,
  chatDocumentIds = [],
  withDocuments,
}) => {
  const { claim } = useClaim();
  const { references = {} } = useChatContext();

  const chatDocuments: ListItem[] = (claim?.documents ?? [])
    .filter((document) => chatDocumentIds.includes(document.id))
    .map((doc) => ({
      id: doc.id,
      chipProps: {
        label: doc.document_name,
        size: 'small',
        variant: 'outlined',
        icon: <FileIcon className="text-slate-700" iconColor="currentColor" />,
        className: 'pl-4',
      },
    }));

  return (
    <div className="__TEXT_CONTAINER__ flex w-full">
      <div className="flex w-full flex-col">
        <div className="flex w-full flex-col">
          {withDocuments && !isEmpty(chatDocuments) ? (
            <OverflowChipsList
              items={chatDocuments}
              overflowChipProps={{
                size: 'small',
                variant: 'outlined',
              }}
            />
          ) : null}
          <CliveMarkdownDisplay content={text} className="mr-8 text-base" references={references} />
        </div>
      </div>
    </div>
  );
};
